import styled from 'styled-components';
import CircleLoader from 'ggApp/shared/components/CircleLoader';

export const StyledCircleLoader = styled(CircleLoader)`
  margin: 32px 0;
`;
